
import axios from './axiosConfig';
import { normalizeAdminUsersPayload } from '../../utils/tenantSubdomain';
import { getProfile } from './profileActions';
import { buildCrossTenantReturnUrl } from '../../pages/Admin/screens/tenantFormUtils';
//import { createBrowserHistory } from "history";
//const API_URL = "https://api.test.raborisk.ai";
const API_URL = process.env.NODE_ENV === 'production' 
    ? "https://api.test.raborisk.ai" 
    : "http://localhost:3000";

export const IMPERSONATOR_TOKEN_KEY = "rabo_impersonator_token";
export const CROSS_TENANT_IMPERSONATION_KEY = "rabo_cross_tenant_impersonation";



    

export const resetAdminError = () => {
    return (dispatch) => {
        dispatch({ type: "RESET_ADMIN_ERROR" });
    };
};

export const resetEditUserOverlay = () => {
    return (dispatch) => {
        dispatch({ type: "EDIT_USER_OVERLAY", user_id: null });
    };
};

export const editUserOverlay = (user_id) => {
    return (dispatch) => {
        dispatch({ type: "EDIT_USER_OVERLAY", user_id: user_id });
    };
};


export const updateUser = (user) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/admin/update_user/", user)
            .then(({ data }) => {
                const { users, viewer } = normalizeAdminUsersPayload(data);
                dispatch({ type: "ADMIN_USERS_UPDATED", users, viewer });
            });
    };
};

export const createUser = (user) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/admin/create_user/", user)
            .then(({ data }) => {
                const { users, viewer } = normalizeAdminUsersPayload(data);
                dispatch({ type: "ADMIN_USERS_CREATED", users, viewer });
            }).catch((error) => {
                ////////console.log(error);
                dispatch({ type: "ADMIN_ERROR", error: error.response.data.error });
            });
    };
};

export const getUsers = () => {
    return (dispatch) => {
        axios.get(API_URL + "/api/admin/get_users/")
            .then(({ data }) => {
                const { users, viewer } = normalizeAdminUsersPayload(data);
                dispatch({ type: "ADMIN_USERS", users, viewer });
                if (viewer) {
                    dispatch({
                        type: "PROFILE_UPDATED",
                        profile: {
                            user_id: viewer.user_id,
                            is_super_admin: viewer.is_super_admin,
                            isMasterDb: viewer.is_master_db === true,
                        },
                    });
                }
            })
            .catch(() => {});
    };
};

export const impersonateUser = (user_id) => {
  return async (dispatch, getState) => {
    const originalToken = getState().auth.token;
    const { data } = await axios.post(API_URL + "/api/admin/impersonate", { user_id });
    if (!data?.token) {
      throw new Error("Impersonation token was not returned");
    }
    if (!sessionStorage.getItem(IMPERSONATOR_TOKEN_KEY) && originalToken) {
      sessionStorage.setItem(IMPERSONATOR_TOKEN_KEY, originalToken);
    }
    return { token: data.token, user: data.user };
  };
};

export const applyImpersonationToken = (token) => {
  return (dispatch) => {
    dispatch({ type: "SWITCH_USER", token });
    dispatch(getProfile());
  };
};

export const returnToSuperAdmin = () => {
  return async (dispatch) => {
    const originalToken = sessionStorage.getItem(IMPERSONATOR_TOKEN_KEY);
    if (!originalToken) {
      throw new Error("Original super admin session was not found");
    }

    const isCrossTenant = sessionStorage.getItem(CROSS_TENANT_IMPERSONATION_KEY) === "1";

    try {
      await axios.post(API_URL + "/api/admin/stop_impersonation");
    } catch {
      // Returning to the locally preserved admin session must still be possible
      // when the short-lived impersonation token has expired.
    }

    sessionStorage.removeItem(IMPERSONATOR_TOKEN_KEY);
    sessionStorage.removeItem(CROSS_TENANT_IMPERSONATION_KEY);

    if (isCrossTenant) {
      const returnUrl = buildCrossTenantReturnUrl(originalToken);
      if (!returnUrl) {
        throw new Error("Master admin return URL could not be built");
      }
      window.location.href = returnUrl;
      return { redirected: true };
    }

    dispatch({ type: "SWITCH_USER", token: originalToken });
    dispatch(getProfile());
    return { redirected: false };
  };
};


export const addUserCompany = (company_id, user_id) => {
  return (dispatch) => {
    return axios
      .post(API_URL + "/api/admin/add_user_company/", {
        company_id,
        user_id,
      })
      .then(() => {
        // refresh users so UI updates
        dispatch(getUsers());
      });
  };
};

export const addUserDepartment = (department_id, user_id) => {
  return (dispatch) => {
    return axios
      .post(API_URL + "/api/admin/add_user_department/", {
        department_id,
        user_id,
      })
      .then(() => {
        dispatch(getUsers());
      });
  };
};


export const suspendUser = (user_id) => {
    return (dispatch) => {
        axios.post(API_URL + "/api/admin/suspend_user/", { user_id: user_id })
            .then(({ data }) => {
                const { users, viewer } = normalizeAdminUsersPayload(data);
                dispatch({ type: "ADMIN_USERS", users, viewer });
            });
    };
};